module.exports = __webpack_public_path__ + "static/img/recharge_btn.9577c02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recharge_btn.png
// module id = YxAT
// module chunks = 0